export type { Config as UsEnConfig } from './us/en';
export { config as usEnConfig } from './us/en';
